import React from 'react';
import { useTranslation } from 'react-i18next';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from 'recharts';

const BodyPartRadarChart = ({ logs }) => {
  const { t } = useTranslation();
  const bodyParts = ['脚', '腕', '肩', '背中', '胸', '腹筋'];
  const JP_TO_KEY = {
    '脚': 'legs', '腕': 'arms', '肩': 'shoulders', '背中': 'back', '胸': 'chest', '腹筋': 'abs'
  };

  // Initialize counts
  const counts = bodyParts.reduce((acc, part) => {
    acc[part] = 0;
    return acc;
  }, {});

  // Aggregate set counts from logs
  logs.forEach(log => {
    if (log.workout_sets) {
      log.workout_sets.forEach(set => {
        if (set.exercise && set.exercise.body_part) {
          if (counts[set.exercise.body_part] !== undefined) {
            counts[set.exercise.body_part] += (set.sets || 1);
          }
        }
      });
    }
  });

  const data = bodyParts.map(part => ({
    subject: t(`body_parts.${JP_TO_KEY[part]}`),
    A: counts[part],
    fullMark: 10, // Placeholder, not strictly needed for auto domain
  }));

  // Determine max value for axis scaling
  const maxVal = Math.max(...data.map(d => d.A));
  const domainMax = maxVal > 0 ? maxVal + 1 : 5;

  if (logs.length === 0) {
    return (
      <div className="w-full h-64 flex items-center justify-center text-gray-500 text-sm">
        {t('no_records_for_date')}
      </div>
    );
  }

  return (
    <div className="w-full h-64" style={{ minHeight: '250px' }}>
      <ResponsiveContainer width="100%" height="100%" minHeight={250} debounce={50}>
        <RadarChart cx="50%" cy="50%" outerRadius="70%" data={data}>
          <PolarGrid stroke="#374151" />
          <PolarAngleAxis
            dataKey="subject"
            tick={{ fill: '#d1d5db', fontSize: 12 }}
          />
          <PolarRadiusAxis
            angle={30}
            domain={[0, domainMax]}
            tick={false}
            axisLine={false}
          />
          <Radar
            name="Sets"
            dataKey="A"
            stroke="#f97316"
            strokeWidth={3}
            fill="#f97316"
            fillOpacity={0.6}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BodyPartRadarChart;
